import React, {forwardRef, useEffect, useState} from 'react';
import SectionLoop from "./SectionLoop";
import Loader from "../../Loader";
import "./PrintCostAndBenefit.scss"
import utilsFunction from "../../../utils/utilsFunction";
import {formatToPersianAddComma, formatToPersianAddCommaNegativeToParentheses} from "../../../utils/CommaSeparator";
import PrintType7Header from "../../Printpage/PrintType7/PrintType7Header";
import PrintType7Footer from "../../Printpage/PrintType7/PrintType7Footer";
import PrintType7Header3 from "../../Printpage/PrintType7/PrintType7Header3";


const BalanceSheetDataPrint = forwardRef((props, ref) => {
  const {data} = props;
  debugger

  const [maxItem, setMaxItem] = useState(0)
  const [totalSum, setTotalSum] = useState({leftSum: 0, rightSum: 0})
   useEffect(() => {
    let leftSum = 0, rightSum = 0;
    if (data.data && Object.keys(data.data).length > 0) {
      data.data.left.forEach(v => {
        v.data.forEach((row, index) => {
          if (index + 1 > maxItem) setMaxItem(index + 1)
          leftSum += utilsFunction.removeParenthesesInNumber(row.remaining)
        })
      })
      data.data.right.forEach(v => {
        v.data.forEach((row, index) => {
          if (index + 1 > maxItem) setMaxItem(index + 1)

          rightSum += utilsFunction.removeParenthesesInNumber(row.remaining)
        })
      })


      setTotalSum({leftSum, rightSum})
    }


  }, [data])

  // return <div ref={ref}> <DummyContent /></div>
  // console.log(data)
  debugger
  return (
    <div
      ref={ref}
      className={'PrintCostAndBenefit'}
    >
      {data !== undefined && Object.keys(data).length === 0 && data.data !== undefined && Object.keys(data.data).length === 0 ?
        <Loader/> :
        <>
          <div>
            <div className={'d-block text-center'}>{data.title}</div>
            <div className={'border border-black p-2'}>
              <PrintType7Header3 title={data.title} data={data}/>
            </div>
          </div>
          <div>
            <div className={"d-flex justify-content-between"}>
              <SectionLoop maxItem={maxItem} data={data.data.right}/>
              <SectionLoop maxItem={maxItem} data={data.data.left}/>
            </div>
            <div>
              <div
                className={"p-3 fw-bold  d-flex justify-content-between rounded border border-black"}>
                <div className={'mx-3 d-flex'}>
                  <div className={'mx-1'}> دارایی :</div>
                  <div className={'ltr'}>  {formatToPersianAddCommaNegativeToParentheses(totalSum.rightSum)}</div>
                </div>
                <div className={'mx-3 d-flex '}>
                  <div className={'mx-1'}>بدهی و سرمایه :</div>
                  <div
                    className={'ltr d-block'}> {formatToPersianAddCommaNegativeToParentheses(totalSum.leftSum)}  </div>
                </div>

              </div>

            </div>
          </div>
          <div>
            <div className={'border border-black p-2'}>
              <PrintType7Footer data={data}/>
            </div>
            <div className={'d-block text-center'}>{data.textUnderPrint}</div>

          </div>
        </>
      }


    </div>
  );
});

export default BalanceSheetDataPrint;
